import { MemberNotification } from "types/notifications";
import { FeatureFlag } from "./api/FeatureFlag";

export const defaultJsaBannerConfiguration: JSABanner = {
    title: `It's time for your annual no-cost health checkup!`,
    firstParagraph:
        "Earn $75 on your ACCESS On-Demand Concierge Card as a thank you for putting your health first. One of the many advantages Alignment Health Plan members receive is a full hour with a provider, helping ensure you're getting the best care and customized benefits to your needs. We can review your health care goals, help remove any barriers in your care, and support care coordination where it's convenient for you - in your home or through a telehealth visit. This service is offered in addition to your routine primary care visits.",
    secondParagraph: `Schedule your no-cost annual health assessment online now through your member portal. Don't wait! Click here to request an appointment with a clinician.`,
    thirdParagraph: 'If you need assistance or would like to schedule your appointment with a Jump Start Associate, please call us at (844) 215-2443.',
    redirectTo: '/jsa-appointment-request',
};

export type NoticeBannerConfig = {
    title: string;
    description: string;
    type: 'info' | 'warning' | 'success' | 'error';
    isActive?: boolean;
};

export interface MemberPortalConfig {
    messageCenterCategories: string[];
    messageCenterPcpCategories: string[];
    homeBanners: Banner[];
    memberCardTemplates: any[];
    memberServicesPhone?: string;
    conciergePhone?: string;
    campaignEligibilityConfigs: MemberPortalCampaignEligibilityConfig[];
    hedisPopUps: HedisPopUpConfig[];
    messageCenterRecipients: MessageCenterRecipient[];
    jsaBanner: JSABanner;
    featureFlags: Record<string, FeatureFlag>;
    noticeBanners?: NoticeBannerConfig[];
    americanLogisticsEnabledDate?: string;
}

export type HedisPopUpConfig = {
    name: string;
    messageCenterCategory: string;
    popUpTitle: string;
    popUpBody: string;
    alertType: 'warning' | 'info' | 'success' | 'danger';
    linkText: string;
    campaignId: string;
    messageCenterRequirement: string;
    messageCenterSubject: string;
};

export type MessageCenterRecipient = {
    name: string;
    categories: string[];
};

export type MemberPortalCampaignEligibilityConfig = {
    name: string;
    campaignId: string;
};
export interface MemberPortalConfigContextType {
    memberPortalConfig: MemberPortalConfig;
    markAsReadMemberNotifications: (number:number) => void;
    archiveNotification: (notificationId:string) =>void;
    memberNotifications: MemberNotificationType;
}

export type Banner = {
    buttonText: string;
    description: string;
    color: string;
    image: string;
    redirectTo: string;
    title: string;
};

export const MemberPortalConfigInitialValue = {
    memberPortalConfig: {
        homeBanners: [],
        memberCardTemplates: [],
        messageCenterCategories: [],
        messageCenterPcpCategories: [],
        campaignEligibilityConfigs: [],
        hedisPopUps: [],
        messageCenterRecipients: [],
        jsaBanner: defaultJsaBannerConfiguration,
        featureFlags: {},
        noticeBanners: [],
    },
    markAsReadMemberNotifications: (number:number) => {},
    archiveNotification: (notificationId:string) => {},
    memberNotifications: {
        dropdownNotifications: [],
        notifications: [],
        archivedNotifications: []
    },
};

export type MemberNotificationType = {
    dropdownNotifications: MemberNotification[];
    notifications: MemberNotification[];
    archivedNotifications: MemberNotification[];
}

export const MemberNotificationTypeEmpty = {
    dropdownNotifications: [],
    notifications: [],
    archivedNotifications: [],
}

export type JSABanner = {
    title: string;
    firstParagraph: string;
    secondParagraph: string;
    thirdParagraph: string;
    redirectTo: string;
};
